import React from 'react';
import { useAuth } from '../context/AuthContext';
import './ImpersonationBanner.css';

const ImpersonationBanner: React.FC = () => {
  const { user, stopImpersonation } = useAuth();

  // Solo mostrar si hay información de impersonificación
  if (!user || !(user as any).isImpersonating) {
    return null;
  }

  const impersonatedUser = user as any;

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
    } catch (error: any) {
      console.error('Error al detener impersonificación:', error.message);
      alert('Error al detener impersonificación: ' + error.message);
    }
  };

  return (
    <div className="impersonation-banner">
      <div className="banner-content">
        <div className="banner-info">
          <span className="banner-icon">👤</span>
          <div className="banner-text">
            <strong>Impersonificando a:</strong> {impersonatedUser.name} ({impersonatedUser.email})
            <br />
            <small>Admin: {impersonatedUser.adminName}</small>
          </div>
        </div>
        <button 
          className="stop-impersonation-btn"
          onClick={handleStopImpersonation}
          title="Detener impersonificación"
        >
          ✕ Salir
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;